// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7qALr","badges":"styles_badges__2bqYW"};